<template>
  <AuthCard>
    <Form :action="`/auth/password/reset/${$route.params.token}`" @success="$router.push({ name: 'auth.login' })">
      <div class="container">
        <input type="hidden" name="token" :value="$route.params.token" />
        <div class="row">
          <div class="col">
            <FormControl name="email" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <FormControl type="password" name="password" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <FormControl type="password" name="password_confirmation" />
          </div>
        </div>

        <div class="row mt-5">
          <div class="col">
            <Button type="submit" class="btn-primary btn-lg btn-rounded w-100">
              {{ $t('front.reset') }}
            </Button>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <Button @click="$router.push({ name: 'auth.login' })" type="submit" class="btn-lg btn-rounded w-100">
              {{ $t('front.sign_in') }}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  </AuthCard>
</template>
<script setup>
import Form from "@/js/Elements/Form/Form.vue";
import AuthCard from "@/js/Views/Auth/AuthCard.vue";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import Button from "@/js/Elements/Button.vue";
</script>